<template>
    <BContainer class="fixed-top">
        <div class="header-icon" @click="returnBack()" v-if="!!back">
            <BImg  :src="back_src" alt="back" style="padding: 0px 12px 3px 0px" ></BImg>
        </div>
        <div class="header-icon" v-if="!!!back"></div>

        <div class="title-wrapper header-title" style="flex-direction: column">
          <BImg v-if="isJcc" :src="jcclogo_src" alt="back" style="padding: 0px 12px 3px 0px" ></BImg>
          <div class="title">{{title}}</div>
        </div>

        <div class="dropdown" v-if="isLogin" @click="toUsrAccount()">
          <BImg :src="isInUserAccount ? user_active_src:user_src" style="padding:0px 2px 3px;"/>
        </div>

        <div style="width: 24px;height: 24px;" v-if="!isLogin"></div>
    </BContainer>
</template>
<script>
import { useRouter } from 'vue-router'
import { watch,ref } from 'vue'

export default {
  name: 'b_header',
  props: {
    title: String,
    back: String,
    params: String,
    isLogin: Boolean,
    isInUserAccount: Boolean,
    buttonStatus: String,
    homeName: String,
    jccFlag:{
      type: Boolean,
      default: false
    },
  },
  setup (props) {
    const router = useRouter()
    const title = ref(props.title)
    const isJcc = ref(props.jccFlag)
    watch(() =>props.title,(newVal,oldVal) => {
      title.value = newVal
    })
    const back = props.back
    const homeName = props.homeName
    const buttonStatus = props.buttonStatus
    const user_src = require('@/assets/icon/user.svg')
    const back_src = require('@/assets/icon/arrow_back_ios.svg')
    const jcclogo_src = require('../assets/icon/logo_jassa.png')
    const user_active_src =  require('@/assets/icon/user_active.svg')
    const isLogin = !!!props.isLogin ? props.isLogin : true
    const isInUserAccount = props.isInUserAccount | false


    function returnBack () {
      if (homeName) {
        router.push({path: back})
        return 
      }
      
      if (back == '/listen/tes/single_answer') {
        router.go(0)
      } if(back == '/listen/tes') {
        router.push({name: 'test'})
      } else if(back == '/usr_inf') {
        router.push({name: 'usr_inf', params: {btnStatus: buttonStatus}})
      } else{
        router.back()
      }
    }

    function toUsrAccount(){
      router.push({path:'/usracc'})
    }

    return {
      back_src,
      user_src,
      user_active_src,
      jcclogo_src,
      title,
      isJcc,
      isLogin,
      isInUserAccount,
      returnBack,
      toUsrAccount
    }
  },
}
</script>

<style lang="scss" scoped>
  .header-title{
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: #30353B;
      vertical-align: middle;
  }
  .container{
    display: flex;
    padding: 7.5px 16px 8px 16px;
    border-bottom: 1px solid;
    height: 40px;
    border-bottom-color: #EEF1F3;
    margin-bottom: 16px;
    background-color: white;
    .header-icon{
      width: 24px;
      height: 24px;
      z-index: 2;
      align-self: center;
    }
    .title-wrapper{
        flex: 1;
        display: flex;
        align-items: center;
        margin-bottom: 0;
        z-index: -1;
        text-align: center;
        padding-bottom: 0px;
        .title{
          flex:1;
          max-height: 20px;
        }
    }
    .dropdown{
      width: 24px;
      height: 24px;
      z-index: 2;
    }
  }
</style>
